module.exports = __webpack_public_path__ + "static/media/19ESCAP24.83c151a7.jpg";